module.exports = __webpack_public_path__ + "static/media/close_light_grey.3e2a2e80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/close_light_grey.svg
// module id = 1036
// module chunks = 36